import { render } from "./ManageCompanyHouseData.vue?vue&type=template&id=579b29c1&scoped=true"
import script from "./ManageCompanyHouseData.vue?vue&type=script&lang=js"
export * from "./ManageCompanyHouseData.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579b29c1"]])

export default __exports__